import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { HIGHLIGHT } from '~pricing/components/Summary/useStyles';
import { Packages } from '~shared/constants/pricing';

import { MD_MEDIA_QUERY, LG_MEDIA_QUERY, XS_MEDIA_QUERY } from '~shared/media-query';
import { Grow2529ExperimentPackages } from '~app/pages/Pricing/experiments/grow_2529_forms/constants';

const PackagesSupported = [...Grow2529ExperimentPackages, Packages.PremierAnnual, Packages.Basic];

type Props = {
  packageName: Packages;
};

type Rules = 'Highlighted' | 'Package';

export default createMemoStyles<Rules, Props, PricingAppTheme>(
  ({ spacing, pricingPalette, packageTheme }: PricingAppTheme) => ({
    Package: {
      position: 'relative',
      border: `1px solid ${pricingPalette.colors.pebble}`,

      [MD_MEDIA_QUERY]: {
        '&:not(:last-of-type):not($Highlighted)': {
          borderRight: 'none',
        },
      },

      '& aside': {
        top: 0,
        right: 0,
        width: '100%',

        '&:before, &:after': {
          display: 'none',
        },

        '& p': {
          transform: 'none',
          top: 'auto',
          left: 0,
          width: '100%',
          fontSize: 13,
        },
      },

      '& header': {
        [XS_MEDIA_QUERY]: {
          paddingTop: ({ packageName }: Props) => (Grow2529ExperimentPackages.includes(packageName) ? 80 : spacing[6]),
        },

        [MD_MEDIA_QUERY]: {
          paddingTop: ({ packageName }: Props) => (PackagesSupported.includes(packageName) ? spacing[8] : spacing[6]),
        },
        '& p': {
          // Package byline
          fontSize: '.875em',
        },

        '& [class*=GROW_2529_Switch]': {
          '& [class*=Values]': {
            [MD_MEDIA_QUERY]: {
              minHeight: 32,
              fontSize: '.6em',
              '& span': {
                padding: [0, '5%'],
              },
            },
            [LG_MEDIA_QUERY]: {
              fontSize: '.75em',
            },
          },
        },
      },
    },

    Highlighted: {
      ...HIGHLIGHT(pricingPalette.colors.flint, packageTheme),
      borderWidth: '3px !important',

      '& header': {
        paddingTop: `${spacing[8] - 2}px !important`,
      },
    },
  })
);
